// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "body{overflow-y:hidden}body *{outline:0}.analytics-website__search-history{min-width:1200px;height:100%;overflow-y:hidden}.analytics-website__search-history .fundation-app{min-width:auto}.integrate-search-history{display:flex;width:100%;background:#fafbfc}.integrate-search-history *{outline:0}.el-tooltip__popper.is-dark{background:#344563!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
